const BACKGROUND_WHITE = 'white-background';
const BACKGROUND_GRAIDENT = 'gradient-background';
const BACKGROUND_GRAPHICS = 'background-graphics';

export { BACKGROUND_WHITE, BACKGROUND_GRAIDENT, BACKGROUND_GRAPHICS };
